enum ComponentType {
  Header = 'HEADER',
  Hero = 'HERO',
  FullWidthImage = 'FULL_WIDTH_IMAGE',
  NonFullWidthImage = 'NON_FULL_WIDTH_IMAGE',
  FullWidthImageOverlay = 'FULL_WIDTH_IMAGE_OVERLAY',
  Paragraph = 'PARAGRAPH',
  ContentColumns = 'CONTENT_COLUMNS',
  FeatureColumns = 'FEATURE_COLUMNS',
  Footer = 'FOOTER',
  Invitation = 'INVITATION',
  Video = 'VIDEO',
  Gallery = 'GALLERY',
  RelatedShows = 'RELATED_SHOWS',
  EmailBox = 'EMAIL_BOX'
}

export default ComponentType
